import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { addEventListener } from '@ifeng-fe/ui_base';
import Slide from './slide';
import Pics from './pics';

/**
 * 定义 Content 组件
 */
class PhotoNews extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        nextSlide: PropTypes.object,
        changePageCallback: PropTypes.func,
    };

    state = {
        showPics: false,
        current: 0,
        total: this.props.content.length || 0,
    };

    // 会调函数，展示全部图片
    clickToShowPics = () => {
        this.setState({ showPics: true });
    };

    //
    clickToShowSlide = () => {
        this.setState({ showPics: false });
    };

    // 页面刷新，hash改变刷新页面
    changePage = () => {
        const { total } = this.state;
        const href = window.location.href;
        const hrefArr = href.split('#');

        if (hrefArr.length > 1 && hrefArr[1].indexOf('p') !== -1) {
            const page = parseInt(hrefArr[1].split('=')[1]);

            // if (page <= total) {
            this.setState({ current: page - 1 });
            // }
            this.props.changePageCallback(page);
        } else {
            // 没有指定页码时，默认为p=1
            window.location.hash = '#p=1';
            this.props.changePageCallback(1);
        }
    };

    // 上一页
    handlePicPrev = () => {
        console.log('pre___');
        const { current } = this.state;

        if (current > 0) {
            window.location.hash = `#p=${current}`;
            // 翻页发送统计
            window.analytics(encodeURIComponent(window.location.href));
        }
    };

    // 下一页
    handlePicNext = () => {
        console.log('next___');
        const { current, total } = this.state;
        const { nextSlide } = this.props;

        if (current < total - 1) {
            window.location.hash = `#p=${current + 2}`;
        } else {
            // 跳转到下一图集
            window.location.href = nextSlide ? nextSlide.url : window.location.href;
        }

        window.analytics(encodeURIComponent(window.location.href));
    };

    // 快捷键
    handleKeyDown = e => {
        if (e.keyCode === 37 || e.keyCode === 39 || e.keyCode === 27) {
            e.preventDefault();
        }

        // const { current, total } = this.state;

        if (e.keyCode === 37) {
            this.handlePicPrev();
        } else if (e.keyCode === 39) {
            this.handlePicNext();
        }
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const { showPics, current } = this.state;
        const currentData = content[current];
        const funcData = {
            changePage: this.changePage,
            handlePicPrev: this.handlePicPrev,
            handlePicNext: this.handlePicNext,
            handleKeyDown: this.handleKeyDown,
            clickToShowPics: this.clickToShowPics,
            clickToShowSlide: this.clickToShowSlide,
        };

        return (
            <div className={styles.photoNews}>
                {showPics ? (
                    <Pics content={content} func={funcData} />
                ) : (
                    <Slide currentData={currentData} func={funcData} />
                )}
            </div>
        );
    }
}

export default errorBoundary(PhotoNews);
